<template>
  <div class="aff_list">
    <div class="aff_top"><span @click="clear_unread">{{$t('beth_text.Clear_unread')}}</span></div>
    <div class="aff_list_box">
      <template v-if="data_list.length">
        <div class="aff_item" :class="item.is_read==0?'font_color':'font_color2'" v-for="item in data_list" :key="item.id">
          <div class="i_title" @click="open_affiche(item)">
            <div class="i_title_left">
              <span class="dian" v-if="item.is_read==0"></span>
              <span class="dian2" v-else></span>
              <span class="l_tit">{{item.title}}</span>
              <span>
                <i v-show="!item.aff_show" class="el-icon-arrow-down"></i>
                <i v-show="item.aff_show" class="el-icon-arrow-up"></i>
              </span>
            </div>
            <div>{{overall_time(item.c_time)}}</div>
          </div>
          <!-- <transition name="fade"> -->
          <!-- <div class="i_text" v-show="item.aff_show">{{item.content}}</div> -->
          <div class="i_text" v-show="item.aff_show" v-html="item.content"></div>
          <!-- </transition> -->
        </div>
        <el-pagination
          v-if="total > 0"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="total"
          @current-change="current_change"
        ></el-pagination>
      </template>
      <template v-else>
        <div class="no_data_txt">
          {{$t('main.text364')}}
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import {list,read,clear} from '@/api/api';
export default {
  data() {
    return {
      currentPage: 1, //选中的页数
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      total: 0, //一共多少条
      data_list: [],
      unread_num:0,//几条未读 为0 请求头部是否还有未读
    };
  },
  mounted() {
    this.get_list();
  },
  beforeDestroy() {
    this.$store.state.is_api_loading=true;
  },
  watch:{
    unread_num(new_val,old_val){
      if(new_val==0 && old_val==1){
        // 请求未读数量 头部红点
        this.bus.$emit("request_unread_num",true);
      }
    }
  },
  methods: {
    current_change(v) {
      // console.log(v);
      this.page = v;
      this.limit = 10;
      this.get_list();
    },
    async get_list(){
      this.unread_num=0;
      const res = await list({page:this.page,limit:this.limit,type:1});
      if(res.data.code!=200){
        return this.message.ismessage('error',res.data.msg);
      }
      const d = res.data.data.data;
      for (const item in d) {
        if(!("aff_type" in d[item])){
          d[item].aff_show = false;
        }
        if(d[item].is_read==0){
          this.unread_num++;
        }
      }
      this.data_list = d;
      this.total = res.data.data.count;
    },
    async open_affiche(item){
      item.aff_show = !item.aff_show;
      if(this.unread_num>0 && item.is_read==0){
        this.unread_num--;
        // 发 已读请求  不要loading
        this.$store.state.is_api_loading=false;
        const res = await read({ids:[item.id]});
        if(res.data.code!=200){
          this.$store.state.is_api_loading=true;
          return this.message.ismessage('error',res.data.msg);
        }else{
          this.$store.state.is_api_loading=true;
        }
      }
      item.is_read = 1;//已读
    },
    async clear_unread(){
      if(this.unread_num){
        const res = await clear({type:1});
        if(res.data.code!=200){
          return this.message.ismessage('error',res.data.msg);
        }
        this.get_list();
        this.bus.$emit("request_unread_num",true);
        return this.message.ismessage('success',this.$t('beth_text.Clear_successfully'));
      }
    }
  },
};
</script>

<style scoped>
.aff_list {
  height: calc(100vh - 163px);
  display: flex;
  flex-direction: column;
}
.aff_top {
  display: flex;
  justify-content: flex-end;
}
.aff_top span {
  cursor: pointer;
  color: #24d69d;
  font-size: 16px;
  margin: 15px 0;
  
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #24d69d;
}
.aff_list_box {
  flex: 1;
  border-radius: 18px;
  background: #232a36;
}
.aff_item {
  border-bottom: 1px solid #020d16;
  font-size: 16px;
  box-sizing: border-box;
  padding: 25px;
}
.font_color {
  color: #fff;
}
.font_color2 {
  color: rgba(255, 255, 255, 0.5);
}
.i_title {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.i_title_left {
  vertical-align: middle;
}
.dian {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f35f65;
}
.dian2 {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
}
.l_tit {
  box-sizing: border-box;
  padding: 0 10px;
}
.i_text {
  box-sizing: border-box;
  padding-top: 15px;
  padding-left: 17px;
}
.i_title_left >>> .el-icon-arrow-up:before {
  content: "\e6e1" !important;
}
/* 折叠面板 过度动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/* ------ */
.no_data_txt{
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
}
</style>
